'use client'

import { cn } from './utils'

type LoadingProps = {
  label?: string
  className?: string
}

export function LoadingInline({ label = 'Chargement…', className }: LoadingProps) {
  return (
    <div className={cn('flex items-center gap-2 text-sm text-muted-foreground', className)}>
      <div className="h-4 w-4 animate-spin rounded-full border-2 border-muted-foreground/30 border-t-primary" />
      <span>{label}</span>
    </div>
  )
}

export function LoadingScreen({ label = 'Chargement…', className }: LoadingProps) {
  return (
    <div className={cn('flex min-h-screen flex-col items-center justify-center gap-4 text-muted-foreground', className)}>
      <div className="h-10 w-10 animate-spin rounded-full border-2 border-muted-foreground/30 border-t-primary" />
      <p className="text-sm">{label}</p>
    </div>
  )
}
